const ambassadorFilter = {};

(function (ambassadorFilterApp) {
    let filterModel = {
        PageSize: 0,
        CurrentPage: 0
    };
    let fromPopState = false;
    let blockPopstateEvent = true;
    const browserSupportsHistoryApi = window.history && 'pushState' in window.history;

    if (browserSupportsHistoryApi) {
        // prevent Chrome from calling onpopstate on initial load
        $(window).on('load', function () {
            // The timeout ensures that popstate-events will be unblocked right
            // after the load event occured, but not in the same event-loop cycle.
            setTimeout(function () { blockPopstateEvent = false; }, 0);
        });

        $(window).on('popstate', function () {
            if (blockPopstateEvent && document.readyState === "complete") {
                return;
            }
            fromPopState = true;
            performSearchFromUrl();
        });
    }

    function pushHistory() {
        if (browserSupportsHistoryApi && !fromPopState) {
            var currentPath = window.location.pathname;
            var query = "?";
            var queryArray = [];
            if (filterModel.CurrentPage && filterModel.CurrentPage > 1) {
                queryArray.push("page=" + filterModel.CurrentPage);
            }
            query += queryArray.join("&");
            history.pushState(null, null, currentPath + query);
        }
        fromPopState = false;
    }

    function performSearchFromUrl() {
        filterModel.CurrentPage = 1;
        if (window.location.search.length > 1) {
            for (var aItKey, nKeyId = 0, aCouples = window.location.search.substr(1).split("&");
                nKeyId < aCouples.length;
                nKeyId++) {
                aItKey = aCouples[nKeyId].split("=");
                if (aItKey.length <= 1)
                    continue;
                var key = decodeURIComponent(aItKey[0]).toLowerCase();
                var val = decodeURIComponent(aItKey[1]);

                if (key === "page") {
                    filterModel.CurrentPage = val;
                }
            }
        }
        ambassadorFilter.GetAmbassadors();
    }

    ambassadorFilterApp.GetAmbassadors = function () {
        $.ajax({
            url: "/umbraco/surface/MBAmbassadorSurface/GetFilterResult",
            type: "GET",
            data: filterModel,
            dataType: "html",
            success: function (data) {
                $(".js-ambassador-filter-result").html(data);
                pushHistory();
            },
            error: function (xhr, status, error) {
                console.log(status);
                console.log(xhr.status + " - " + error);
            }
        });
    };

    $(document).ready(function () {
        //Get url params on load
        const urlParams = new URLSearchParams(window.location.search);

        //check if querystring params exist on load/reload
        if (urlParams.get('page'))
            filterModel.CurrentPage = urlParams.get('page');

        function setFilterModel() {
            filterModel.CurrentPage = parseInt($(".js-pagination").data("currentpage"));
            filterModel.PageSize = $(".js-ambassador-filter-result").data("pagesize");
        }

        setFilterModel();

        $(document).on("click", ".js-next-pagination-button", function (e) {
            e.preventDefault();
            if ($(this).hasClass("pagination__button--disabled")) return;

            setFilterModel();
            filterModel.CurrentPage = filterModel.CurrentPage + 1;
            ambassadorFilter.GetAmbassadors();
            paginationScrollToTop();
        });

        $(document).on("click", ".js-back-pagination-button", function (e) {
            e.preventDefault();
            if ($(this).hasClass("pagination__button--disabled")) return;

            setFilterModel();
            filterModel.CurrentPage = filterModel.CurrentPage - 1;
            ambassadorFilter.GetAmbassadors();
            paginationScrollToTop();
        });

        $(document).on("change", "#js-blog-article-pagination-input", function () {
            const currentPage = parseInt($(this).val());
            const pageCount = parseInt($(".js-pagination").data("pagecount"));
            if (currentPage > 0 && currentPage <= pageCount) {
                filterModel.CurrentPage = currentPage;
                filterModel.PageSize = $(".js-ambassador-filter-result").data("pagesize");
                ambassadorFilter.GetAmbassadors();
                paginationScrollToTop();
            }
        });
        
        function paginationScrollToTop() {
            $('html, body').animate({
                scrollTop: $(".js-pagination-scroll-to").offset().top - $("header").outerHeight()
            }, 400);
        }
    });

})(ambassadorFilter);
